import React from 'react';
import styled from 'styled-components';
import fontStyles from './font-styles';
const Root = styled.div `
  ${fontStyles};
  position: relative;
  padding: 8px;
  background: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  text-align: center;
  font-size: 12px;
  line-height: 1.3;
`;
const Content = styled.div `
  .link {
    text-decoration: underline;
    cursor: pointer;
  }
  .button {
    position: relative;
    margin-left: 14px;
    padding: 0 14px;
    border: none;
    background: #4fb767;
    color: white;
    border-radius: 8px;
    font: inherit;
    height: 30px;
    line-height: 30px;
    font-weight: 700;
    text-align: center;
    display: inline-block;
    outline: 0;
    user-select: none;
    text-decoration: none;
    transition: all 0.4s ease;
    cursor: pointer;
    &:hover {
      color: white;
      background: #068c5a;
      text-decoration: none;
    }
    &.personnalize {
      color: #031b4a;
      background-color: #f7f9fa;
      &:hover {
        background-color: #f2f4f6;
      }
      &:focus {
        background-color: #f2f4f6;
      }
      &:active {
        background-color: #f2f4f6;
      }
    }
  }
`;
const P = styled.p `
  margin: 0;
  strong {
    font-size: 14px;
  }
  a {
    color: white;
    font-size: 12px;
    text-decoration: underline;
  }
`;
const Banner = ({ innerRef, onClose, lang, showBanner, allowSmallBannerOnClose, onChangePreferences, backgroundColor, textColor, }) => {
    return showBanner === true ? (React.createElement(Root, { className: lang, ref: innerRef, backgroundColor: backgroundColor, textColor: textColor },
        React.createElement(Content, null, lang === 'it' ? (React.createElement(P, null,
            React.createElement("strong", null, "Informativa"),
            React.createElement("br", null),
            "Il presente sito web utilizza cookie tecnici e, previo Suo consenso, cookie di profilazione e analitici per inviare messaggi pubblicitari in linea con le preferenze manifestate nell\u2019ambito dell\u2019utilizzo delle funzionalit\u00E0 e della navigazione in rete e allo scopo di effettuare analisi e monitoraggio dei comportamenti dei visitatori. Ulteriori informazioni sono disponibili",
            ' ',
            React.createElement("a", { className: "link", href: "https://www.iziwork.com/it/informativa-sulla-privacy/", target: "_blank", rel: "noopener noreferrer" }, "qui"),
            ". Per impostare le Sue preferenze",
            ' ',
            React.createElement("a", { className: "link", onClick: onChangePreferences }, "clicchi qui"),
            ". Cliccando su \u201CAccetto\u201D acconsente all\u2019installazione di tutti i cookie.",
            React.createElement("button", { type: "button", className: "button personnalize", onClick: onChangePreferences }, "Scegli e personalizza"),
            React.createElement("button", { type: "button", className: "button", id: "accept", onClick: onClose }, "Accetto"))) : (React.createElement(P, null,
            React.createElement("strong", null, "Votre vie priv\u00E9e \uD83C\uDF6A"),
            React.createElement("br", null),
            "Nous utilisons des cookies et d'autres technologies similaires afin de personnaliser notre contenu, mesurer l'efficacit\u00E9 de nos publicit\u00E9s et am\u00E9liorer leur pertinence, ainsi que proposer une meilleure exp\u00E9rience. En cliquant sur OK ou en activant une option dans Pr\u00E9f\u00E9rences de cookies, vous acceptez les conditions \u00E9nonc\u00E9es dans notre",
            ' ',
            React.createElement("a", { className: "link", href: "https://www.iziwork.com/fr/politique-de-confidentialite/", target: "_blank", rel: "noopener noreferrer" }, "Politique en mati\u00E8re de cookies"),
            ". Pour modifier vos pr\u00E9f\u00E9rences ou retirer votre consentement, vous devez mettre \u00E0 jour vos Pr\u00E9f\u00E9rences de cookies.",
            ' ',
            React.createElement("button", { type: "button", className: "button personnalize", onClick: onChangePreferences }, "Pr\u00E9f\u00E9rences de cookies"),
            React.createElement("button", { type: "button", className: "button", id: "accept", onClick: onClose }, "Ok")))))) : ((showBanner === false && allowSmallBannerOnClose === true) ? (React.createElement(Root, { className: `${lang} small-banner`, ref: innerRef, backgroundColor: backgroundColor, textColor: textColor }, lang === 'it' ? (React.createElement(P, null,
        "Il presente sito web utilizza cookie tecnici \uD83C\uDF6A.",
        ' ',
        React.createElement("a", { type: "button", className: "link", onClick: onChangePreferences }, "Preferenze"))) : (React.createElement(P, null,
        "Notre site internet utilise des cookies \uD83C\uDF6A.",
        ' ',
        React.createElement("a", { type: "button", className: "link", onClick: onChangePreferences }, "Param\u00E8tres"))))) : null);
};
export default Banner;
//# sourceMappingURL=data:application/json;base64,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